import { civilDateKey, isWeekend } from './day-helpers.js';
import type { Holiday, ObservedHoliday, SkippedDate } from './types.js';

export function buildObservedHolidays(
  holidayMap: Map<string, Holiday>,
  windowStart: Date,
  windowEnd: Date,
): ObservedHoliday[] {
  const result: ObservedHoliday[] = [];
  for (const h of holidayMap.values()) {
    const t = h.date.getTime();
    if (t >= windowStart.getTime() && t <= windowEnd.getTime()) {
      result.push({ date: h.date, name: h.name });
    }
  }
  result.sort((a, b) => a.date.getTime() - b.date.getTime());
  return result;
}

export function classifyDay(
  date: Date,
  holidayMap: Map<string, Holiday>,
): { isCounting: boolean; skip?: SkippedDate } {
  if (isWeekend(date)) {
    return { isCounting: false, skip: { date, reason: 'weekend' } };
  }
  const holiday = holidayMap.get(civilDateKey(date));
  if (holiday !== undefined) {
    return { isCounting: false, skip: { date, reason: 'public-holiday', name: holiday.name } };
  }
  return { isCounting: true };
}
